import type { ReactNode } from 'react';
import type { IconComponent } from '../../types';
import { CdHeading, CdText } from '../../atoms/CdTypography';
import { cx } from '../../utils';
import styles from './CdEmptyState.module.scss';

export interface CdEmptyStateProps {
  icon?: IconComponent;
  title: string;
  description?: string;
  action?: ReactNode;
  /** `page` fills a large area (no results, map failed); `compact` for panels/cards. */
  size?: 'page' | 'compact';
  className?: string;
}

/** Used for: no search results, no applications yet, no notifications, map failed to load. */
export const CdEmptyState = ({
  icon: Icon,
  title,
  description,
  action,
  size = 'compact',
  className,
}: CdEmptyStateProps) => {
  return (
    <div className={cx(styles.root, styles[size], className)}>
      {Icon && <Icon className={styles.icon} size={32} aria-hidden="true" />}
      <CdHeading level={3} size="md">
        {title}
      </CdHeading>
      {description && (
        <CdText variant="small" tone="secondary">
          {description}
        </CdText>
      )}
      {action && <div className={styles.action}>{action}</div>}
    </div>
  );
};
